
const Footer = () => {
  return (
    <section className="pb-8 bg-black position-relative overflow-hidden pt-10">
      <div className="container position-relative">        
        <div className="text-center">
          <p className="fs-9 text-secondary-light mb-0">Copyright © 2023 Hire code. All Rights Reserved</p>
        </div>
      </div>
    </section>
  )
}

export default Footer;